import clsx from 'clsx';
import Button from '../../basic/button';
import QuickLink from '../../basic/quickLink';
import { Banner } from '../banner';
import { Card, CardActions, CardContent, CardHeader } from '../card';
import { MarketingTileProps } from './IMarketingGrid';
import { DataAnalyticsLocations, DataAnalyticsTypes, buildAnalytics } from '../../basic/analytics';

const MarketingTile = ({
  banner,
  parentAnalyticsLocation,
  tileIndex,
}: MarketingTileProps): JSX.Element => {
  const card = banner.card;
  const buttonDataAnalytics = buildAnalytics(
    DataAnalyticsLocations.Card,
    DataAnalyticsTypes.Button,
    [parentAnalyticsLocation, DataAnalyticsLocations.Tile],
  );
  return (
    <Banner
      className="lg:w-2/6"
      media={banner.src}
      mediaStyle="rounded-t-md xl:rounded-sm aspect-w-16 aspect-h-9 lg:aspect-w-1 lg:aspect-h-1"
      layout="center-facing"
      data-testid="marketing-tile"
      cardLayout={card?.tileLayout}
      enableMobileStack={true}
      alt={banner?.alt}
      aria-label={`tile ${tileIndex + 1}`}
    >
      {card && (
        <Card
          theme={card.theme}
          className={clsx(
            card.theme,
            'bg-card-fill flex-col lg:min-h-[320px] bg-white px-md py-md space-y-md xl:rounded-2xl w-full md:border shadow-xl md:shadow-none rounded-t-none 2xl:w-3/6 xl:w-4/6 xl:mt-[-7rem]',
            {
              'xl:ml-sm': card.tileLayout === 'left-facing',
              'xl:mr-xl': card.tileLayout === 'right-facing',
            },
          )}
        >
          <CardHeader header={card.header} className="text-md text-inky" />
          <CardContent description={card.description} className="text-sm text-inky" />
          <CardActions className="flex-row space-x-sm">
            {card?.navigation &&
              card?.navigation.map((btn: any, idx: number) => {
                return (
                  <Button
                    link={btn.url}
                    key={idx}
                    aClass="inline-block p-[1px]"
                    shape="rounded"
                    border={true}
                    dataAnalytics={buttonDataAnalytics}
                    //  aria-hidden={false}
                    className="p-sm text-sm font-medium bg-btn-fill text-btn-base border-btn-border hover:bg-btn-hover hover:text-btn-hover-text min-w-[100px] px-[24px]"
                  >
                    {btn.title}
                  </Button>
                );
              })}
          </CardActions>
        </Card>
      )}
    </Banner>
  );
};

export default MarketingTile;
